import React from 'react'

const Loading = () => <div className='spinner-border' role='status' />

export default Loading
